import React from 'react';
import {Overlay} from 'react-bootstrap';
import '../../style/PopoverButton.less';
import useOnclickOutside from "react-cool-onclickoutside";

function PopoverButton({
                           placement,
                           title,
                           content,
                           buttonTitle,
                           buttonIcon,
                           className
                       }) {
    const [show, setShow] = React.useState(false);
    const target = React.useRef(null);
    const ref = React.useRef(null);

    useOnclickOutside(
        () => {
            setShow(false);
        },
        {refs: [ref]}
    );

    const popover = () => {
        return (
            <div id="popover-content">
                {
                    !!title &&
                    <h3>{title}</h3>
                }
                <div>
                    {content}
                </div>
            </div>
        );
    };

    return (
        <div ref={ref} className={"inline-row"}
        >
            <button
                className={className ? className : "popover-button-default"}
                ref={target}
                onClick={(e) => {
                    e.stopPropagation();
                    setShow(!show);
                }}>
                {buttonIcon ? buttonIcon : ""}
                {buttonTitle ? buttonTitle : ""}
            </button>
            <Overlay
                target={target.current}
                show={show}
                container={ref.current}
                placement={placement}
            >
                {() => (
                    <div className="popover-container">
                        {popover()}
                    </div>
                )}
            </Overlay>
        </div>
    );
}

export default PopoverButton;

